import {ContextMenuEntry} from './context-menu-entry';

export class ContextState {
  context?: ContextMenuEntry[];
  top?: number;
  left?: number;
}
